module.exports = __webpack_public_path__ + "img/image-3.ff50d0aa.jpg";